<template>
  <div :class="['material-share', { 'material-share--vertical': vertical }]">
    <span>поделиться {{ vertical ? 'статьей' : '' }}</span>
    <share-network
      network="Odnoklassniki"
      :url="materialLink"
      :title="material.title || ''"
      :description="material.previewText || ''"
    >
      <img
        src="/img/materials/material/odnoklassniki.png"
        alt="одноклассники"
      >
    </share-network>
    <share-network
      network="WhatsApp"
      :url="materialLink"
      :title="material.title || ''"
      :description="material.previewText || ''"
    >
      <img
        src="/img/materials/material/whatsapp.png"
        alt="WhatsApp"
      >
    </share-network>
    <share-network
      network="Telegram"
      :url="materialLink"
      :title="material.title || ''"
      :description="material.previewText || ''"
    >
      <img
        src="/img/materials/material/telegram.png"
        alt="Telegram"
      >
    </share-network>
    <share-network
      network="VK"
      :url="materialLink"
      :title="material.title || ''"
      :description="material.previewText || ''"
    >
      <img
        src="/img/materials/material/vk.png"
        alt="VK"
      >
    </share-network>
    <button
      class="m-btn"
      @click="copyLink"
    >
      <img
        src="/img/materials/material/link.png"
        alt="copy link"
      >
    </button>
  </div>
</template>

<script>
export default {
  name: 'MaterialShare',
  props: {
    material: {
      type: Object,
      required: true,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    materialLink() {
      if (process.client) {
        return `${window.location.origin}${this.$route.fullPath}`;
      }
      return `https://school.synergy.ru${this.$route.fullPath}`;
    },
  },
  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.materialLink);
    },
  },
};
</script>

<style scoped lang="scss">

.material-share {
  display: flex;
  align-items: center;
  gap: calc(var(--scale) * 4);

  span {
    display: inline-block;
    margin-right: calc(var(--scale) * 4);
    font-weight: 400;
    font-size: calc(var(--scale) * 20);
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      font-size: calc(var(--scale) * 16);
    }
  }

  button,
  a {
    line-height: 0;
  }

  img {
    width: calc(var(--scale) * 40);
    height: calc(var(--scale) * 40);
  }
}

.material-share--vertical {
  flex-wrap: wrap;
  justify-content: flex-end;

  span {
    display: block;
    width: 100%;
    margin-right: 0;
    margin-bottom: calc(var(--scale) * 4);
    text-align: right;
  }
}

</style>
